
<template>
    <div class="block_inp internal_doc p-3">
        
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_name">
                Номер *
            </label>
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                </div>
                <input id="advanced_name" type="text" class="form-control" v-model="doc.number">
            </div>
        </div>
        
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_name">
                Тема*
            </label>
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                </div>
                <input id="advanced_name" type="text" class="form-control" v-model="doc.title">
            </div>
        </div>
        
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_name">
                Дата документа*
            </label>
            <div class="input-group flex-nowrap">
                <date-picker
                    value-type="format"
                    v-model="doc.doc_date"
                    :lang="d_lang"
                    confirm
                    :first-day-of-week="1">
                </date-picker>
            </div>
        </div>
        
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_name">
                Стислий опис*
            </label>
            
            <div class="input-group flex-nowrap">
                <vue-editor
                    class="w-100"
                    :editor-toolbar="editor_rules"
                    id="trip_preamblua"
                    v-model="doc.description">
                </vue-editor>
            </div>
        </div>
        
        <div class="template mt-5 pt-5" >
            <organization_select
                @on_organization_set="set_org_id"
                :active_id="parseInt(doc.tov_id)">
            </organization_select>
        </div>
        
        <div class="form-group mt-4">
            <label class="form-label" >
                Тип документа*
            </label>
            
            <div class="" v-if="doc_types.length > 0">
                <v-select
                    :reduce="active_doc => active_doc.id"
                    v-model="doc.type_id"
                    class="imc_reasons"
                    label="title"
                    :options="this.doc_types"
                    :filterable="false"
                >
                    <template slot="no-options">
                        Оберіть Тип(и)
                    </template>
                    
                    <template slot="option"  slot-scope="option">
                        <div class="d-center">
                            {{ option.title }}
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Organization_select from "../../../../shared/select/organization_select.vue";
import vSelect from 'vue-select';

export default {
    name: "internal_main",
    
    components : {
        Organization_select,
        DatePicker,
        vSelect
    },
    
    props : {
        doc : {
            type : Object
        }
    },
    
    data() {
        return {
            doc_types : [],
        }
    },
    
    created() {
        this.load_types();
    },
    
    methods : {
        
        set_org_id(org_id) {
            this.doc.tov_id = org_id;
        },
        
        async load_types () {
            this.tovs = [];
            await api.get('/internal/docs/types').then(({data}) => {
                if (data.status === "operation_success") {
                    this.doc_types = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
    },
    
    computed : {
        ed_height () {
            return "150";
        },
        editor_rules () {
            return [
                ["bold", "italic", "underline", "link"],
                [{align: "center"}, {align: "right"}, {align: "justify"}],
                [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
            ]
        },
        
        d_lang () {
            return this.get_datepickLang();
        },
    }
}
</script>

<style scoped>

</style>